// import React from 'react';
// import './PricingTable.scss'; // Import your SCSS file

// const PricingTable = () => {
//   return (
//     <div className="pricingTable ">
//       <h2 className="pricingTable-title">Find a plan that's right for you.</h2>
     
//       <h3 className="text- text-4xl text-highlight mb-8 lg:mb-16">
//                     {"<"} Our PricingTable {"/>"}
//                 </h3>
//       <ul className="pricingTable-firstTable ">
//         <li className="pricingTable-firstTable_table body_">
//           <h1 className="pricingTable-firstTable_table__header">Bronze Package</h1>
//           <p className="pricingTable-firstTable_table__pricing"><span>$</span><span>80</span><span>3Day</span></p>
//           <ul className="pricingTable-firstTable_table__options">
//             <li>1 Page Static Site</li>
//             <li>Responsive - Site set up</li>
//             <li>Business Emails</li>
//           </ul>
//           <button className="pricingTable-firstTable_table__getstart"><a href='mailto:mdshakil6565a@gmail.com'>Hire me Now</a></button>
//         </li>
//         <li className="pricingTable-firstTable_table body_">
//           <h1 className="pricingTable-firstTable_table__header">Gold Package</h1>
//           <p className="pricingTable-firstTable_table__pricing"><span>$</span><span>140</span><span>6Day</span></p>
//           <ul className="pricingTable-firstTable_table__options">
//             <li>Up to 7 Pages Informational Site</li>
//             <li>Responsive</li>
//             <li>Complete site set up</li>
//             <li>Business Emails</li>
//             <li>24/7 Support Service</li>
//           </ul>
//           <button className="pricingTable-firstTable_table__getstart"><a href='mailto:mdshakil6565a@gmail.com'>Hire me Now</a></button>
//         </li>
//         <li className="pricingTable-firstTable_table body_">
//           <h1 className="pricingTable-firstTable_table__header">Platinum Package</h1>
//           <p className="pricingTable-firstTable_table__pricing"><span>$</span><span>250</span><span>10Day</span></p>
//           <ul className="pricingTable-firstTable_table__options">
//             <li>Up to 15 Pages</li>
//             <li>Complete site set up</li>
//             <li>A</li>
//           </ul>
//           <button className="pricingTable-firstTable_table__getstart"><a href='mailto:mdshakil6565a@gmail.com'>Hire me Now</a></button>
//         </li>
//       </ul>
//     </div>
//   );
// }

// export default PricingTable;



'use client'


import { Building2,CircleMinus, CalendarDays, X, CalendarMinus, Check, User } from "lucide-react";
import React, { useState } from "react";

const PricingTable = () => {
  const [isMonthlyPlan, setIsMonthlyPlan] = useState(true);

  const togglePlan = () => {
    setIsMonthlyPlan(!isMonthlyPlan);
  };

  return (
    <div className="flex flex-col space-y-10  pb-20 items-center justify-center">
      <div className="space-y-6 flex flex-col text-center pt-20 px-10 md:px-0">
      {/* <h3 className="text- text-4xl text-highlight mb-8 lg:mb-16">
                    {"<"} Our PricingTable {"/>"}
                 </h3> */}
                 <h3 className="text- flex justify-center text-4xl mb-6 text-highlight">
                <div className='flex gap-3 items-center  border-[2px] w-[345px] border-white py-1 px-5 hover:bg-white hover:text-black rounded-3xl'>Our PricingTable <span className="hover:rotate-180 "> <img className="w-6 h-6" alt="imag" loading="lazy" src="https://i.ibb.co/G3xK0m8/im.png"/></span></div>

                    {/* {"<"} Who Am I {"/>"} */}
                </h3>

        <div className="text-5xl">Easily organize your work. Start free.</div>
        <div className="text-2xl text-gray-500">
          Access Birds features. No credit card required
        </div>
      </div>

      <div className="flex px-10 md:px-0">
        <button
          className={`${
            isMonthlyPlan
              ? "bg-blue-500 text-white "
              : "bg-gray-100 text-gray-600"
          } p-4 rounded-l-lg focus:outline-none w-40 md:w-80`}
          onClick={() => setIsMonthlyPlan(true)}
        >
          <div className="flex items-center justify-center space-x-4">
            <CalendarMinus size={24} />
            <div className="text-2xl">Monthly</div>
          </div>
        </button>
        <button
          className={`${
            !isMonthlyPlan
              ? "bg-blue-500 text-white"
              : "bg-gray-100 text-gray-600"
          } p-4 rounded-r-lg focus:outline-none w-40 md:w-80`}
          onClick={() => setIsMonthlyPlan(false)}
        >
          <div className="flex items-center justify-center space-x-4">
            <CalendarDays size={24} />
            <div className="text-2xl">Yearly</div>
          </div>
        </button>
      </div>

      <div className="">
        <div
          className={`${
            isMonthlyPlan ? "block" : "hidden"
          } text-center  text-2xl`}
        ></div>
        <div className="md:flex  lg:p-10 p-4 md:space-x-10 space-y-10 md:space-y-0 items-center justify-center md:w-/4 md:mx-auto">
          <div data-aos="fade-up" className="border-gray-500  p-10 rounded-lg border space-y-8 md:w-1/2 ">
            <div className="text-2xl">Basic</div>
            <div className="text-xl">
              For teams that need to create project plans with confidence.
            </div>

            <div className="text-5xl font-semibold">US $100</div>

            <div className="">
              
            </div>

            <div className="text-center">
              <a href="mailto:mdshakil6565a@gmail.com">
                <button className="bg-blue-500 text-white px-4 py-2 rounded-lg text-xl w-full">
                Contact Sales
              </button></a>
            </div>

            <div className="text-2xl underline text-center">Purchase Now</div>

            <div>Manage tasks and personal to-dos:</div>
            <div className="flex space-y-6 flex-col  p_Text">
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500"> 1 Page Static Site</div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Responsive design

                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Site set up
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Business Emails
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Functional website
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Content upload

                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                 
                  <X  size={24}/>
                </div>
                <div className="text-gray-500">
                E-commerce functionality
                </div>
              </div>
             
              <div className="flex space-x-6">
                <div>
                <X  size={24}/>
                </div>
                <div className="text-gray-500">
                Payment processing
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Opt-in form

                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Autoresponder integration
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Speed optimization

                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Social media icons


                </div>
              </div>

              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Hosting setup
                </div>
              </div>
              <div className="flex space-x-6">
                <div className="text-22px] l">
                <div>
                  <Check size={24} />
                </div>
                </div>
                <div className="text-gray-500">
                Number of pages 1
                </div>
              </div>
              <div className="flex space-x-6">
                <div className="mr-4">
                 2
                </div>
                <div className="text-gray-500">
                Days  Delivery Time   
                               
                </div>
              </div>

              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                    24/7 Customer Support
                </div>
              </div>
            </div>
          </div>

          <div data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500"  className="border-purple-500 p-10 sm:p- rounded-lg border space-y-8  md:w-1/2">
            <div className="text-2xl">Standard</div>
            <div className="text-xl">
              For teams that need to create project plans with confidence.
            </div>
            {isMonthlyPlan ? (
                <div>
                            <div className="text-5xl font-semibold">US $200</div>
                </div>
            ) : (
                <div className="text-5xl font-semibold">US $1900</div>
            )
                    }
    

            <div className="">
             
            </div>

            <div className="text-center">
            <a href="mailto:mdshakil6565a@gmail.com">
              <button className="bg-blue-500 text-white px-4 py-2 rounded-lg text-xl w-full">
               Contact Sales
              </button>
              </a>
            </div>

            <div className="text-2xl underline text-center">Purchase Now</div>

            <div>Everything in Basic, plus :</div>
            <div className="flex space-y-6 flex-col">
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Up to 6 Pages
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Informational Site
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Responsive design


                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Complete site set up
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                        
                Business Emails
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                        
                Opt-in form
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <X size={24} />
                </div>
                <div className="text-gray-500">E-commerce functionality</div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <X size={24} />
                </div>
                <div className="text-gray-500">Payment processing</div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">Functional website</div>
              </div>
              
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">Content upload
</div>
              </div>
              {/* <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">Templates</div>
              </div> */}
            
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">Speed optimization
 </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">Hosting setup integration</div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">Social media icons
 In.</div>
              </div>
              <div className="flex space-x-6">
                <div className="text-[22x] ">
                <div>
                  <Check size={24} />
                </div>
                </div>
                <div className="text-gray-500">Number of pages 6</div>
              </div>
              <div className="flex space-x-6">
                <div className="mr-4">
                5
                </div>
                <div className="text-gray-500">
                Days  Delivery Time   
                                                                                            
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                    24/7 Customer Support
                </div>
              </div>
            </div>
          </div>


          <div data-aos="fade-down" className="border-teal-500 p-10 rounded-lg border space-y-8 md:w-1/2">
            <div className="text-2xl">Premium</div>
            <div className="text-xl">
              For teams that need to create project plans with confidence.
            </div>
            {isMonthlyPlan ? (
                <div>
                            <div className="text-5xl font-semibold">US $350</div>
                </div>
            ) : (
                <div className="text-5xl font-semibold">US $3600</div>
            )
                    }
    

            <div className="">
              {/* Per user, per month billed annually US $144.00 */}
            </div>

            <div className="text-center">
             <a href="mailto:mdshakil6565a@gmail.com">
               <button className="bg-blue-500 text-white px-4 py-2 rounded-lg text-xl w-full">
                Contact Sales
              </button></a>
            </div>

            <div className="text-2xl underline text-center">Purchase Now</div>

            <div>Everything in Premium, plus :</div>
            <div className="flex space-y-6 flex-col">
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Up to 13 Pages
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                        
                Responsive design
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                        
                Complete site set up
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                        
                Business Emails
                </div>
              </div>

              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Functional website
                </div>
              </div>
              
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                        
                Content upload

                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                        
                E-commerce functionality
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                        
                Payment processing 
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                        
                Opt-in form
  
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                        
                Autoresponder integration
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Speed optimization
   
                                                  
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                        
                Hosting setup
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Social media icons  
                                                                      
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                Number of pages 10       
                                                                                           
                </div>
              </div>
              <div className="flex space-x-6">
                <div className="mr-4">
                 10 
                </div>
                <div className="text-gray-500">
                Days  Delivery Time   
                                                                                            
                </div>
              </div>
              <div className="flex space-x-6">
                <div>
                  <Check size={24} />
                </div>
                <div className="text-gray-500">
                    24/7 Customer Support
                </div>
              </div>
            </div>
          </div>

 
        </div>
        </div>
  
      


    </div>
  );
};





export default PricingTable;
